import kamala from '../../kamala'
import Tooltip, { TooltipType } from './Tooltip'

Tooltip.install = function (Vue) {
  kamala(Vue)

  Vue.component(Tooltip.name, Tooltip)
}

export {
  Tooltip,
  TooltipType,
}

export default Tooltip
